// Test hook: `?__crash=<scope>` throws inside the matching boundary so the fallback can be exercised end-to-end. Renders nothing otherwise.
export default function CrashProbe({ scope }) {
  if (new URLSearchParams(window.location.search).get("__crash") === scope) throw new Error(`Deliberate render error (${scope})`);
  return null;
}
